import { useQuery } from '@tanstack/react-query';
import { api, type LearnerAccessibleBankScope, type QuestionBank } from '../lib/api';
import { getExamType } from '../lib/userPreferences';

export const queryKeys = {
  banks: ['banks'] as const,
  banksByExamType: (examType: string | null) => ['banks', examType] as const,
  accessibleBanks: (scope: LearnerAccessibleBankScope = {}) =>
    [
      'accessibleBanks',
      scope.languageId ?? null,
      scope.examType ?? null,
      scope.section ?? null,
    ] as const,
  mistakes: (page: number) => ['mistakes', page] as const,
} as const;

export function useBankList() {
  const selectedExamType = getExamType();

  return useQuery({
    queryKey: queryKeys.banksByExamType(selectedExamType),
    queryFn: async () => {
      const result = await api.banks.list();
      if (!result?.banks || !Array.isArray(result.banks)) {
        throw new Error('API 响应格式错误');
      }

      const filteredBanks = selectedExamType
        ? result.banks.filter((bank) => {
            const bankType = (bank.examType ?? '').toString().toLowerCase();
            return bankType === selectedExamType.toLowerCase();
          })
        : result.banks;

      return filteredBanks as QuestionBank[];
    },
  });
}

export function useAccessibleBanks(scope: LearnerAccessibleBankScope = {}) {
  return useQuery({
    queryKey: queryKeys.accessibleBanks(scope),
    queryFn: async () => {
      const result = await api.banks.myAccessible(scope);
      return result?.banks ?? [];
    },
  });
}
